import { Moment } from 'moment';

export const getDateString = (date: Moment) => {
  return date.format('DD.MM.YYYY');
};

export const substractDays = (dateInUnix: number, days: number): number => {
  const daysInSeconds = Math.trunc(days * 24 * 3600);

  return dateInUnix - daysInSeconds;
};

export const addDaysToDate = (dateInUnix: number, days: number): number => {
  const daysInSeconds = Math.trunc(days * 24 * 3600);

  return dateInUnix + daysInSeconds;
};

export const convertSecondsToHours = (seconds: number, accuracy = 100000): number => {
  return Math.trunc((seconds * accuracy) / 3600) / accuracy;
};

export const convertHoursToSeconds = (hours: number): number => {
  return Math.trunc(hours * 3600);
};
